import { useMemo } from 'react';
import { SelectionDto, SelectionsTemplate } from '../../../api/sbapi/sbapi-api-model';
import { formatDynamicTextKey, textKeyIsSet } from '../../../utils/sportsbook-route-utils';
import useTranslations from '../../../../../translation/use-translations';

const DYNAMIC_PLACEHOLDER_SELECTION_TEMPLATE_ID = '{selectionTemplateId}';
const SELECTION_TEMPLATE_HEADER = `SPORTSBOOK_SELECTION_TEMPLATE_${DYNAMIC_PLACEHOLDER_SELECTION_TEMPLATE_ID}_HEADER`;

const getTextKeyForSelectionTemplateId = (selectionTemplateId: string) =>
	formatDynamicTextKey(SELECTION_TEMPLATE_HEADER, DYNAMIC_PLACEHOLDER_SELECTION_TEMPLATE_ID, selectionTemplateId);

const useSelectionsTemplateTranslations = (selectionsTemplate: SelectionsTemplate) => {
	const textKeys = useMemo(
		() => selectionsTemplate.map(template => getTextKeyForSelectionTemplateId(template.id)),
		[selectionsTemplate]
	);

	return useTranslations(textKeys, true);
};

/**
 * Create a map of selection id to selection title based on shouldClearSelectionTitle.
 */
const useSelectionIdToTitle = (
	selections: SelectionDto[],
	selectionsTemplate: SelectionsTemplate | undefined,
	shouldClearSelectionTitle: boolean
) => {
	const { translate } = useSelectionsTemplateTranslations(selectionsTemplate || []);

	return useMemo(() => {
		return selections.reduce<Record<string, string>>((map, selection) => {
			if (shouldClearSelectionTitle) {
				return {
					...map,
					[selection.id]: ''
				};
			}

			const translation = translate(getTextKeyForSelectionTemplateId(selection.templateId), {
				points: selection.points
			});

			return {
				...map,
				// If the translation for selection template is not set, use the selection betslipLine as fallback.
				[selection.id]: textKeyIsSet(translation) ? translation : selection.betslipLine
			};
		}, {});
	}, [selections, shouldClearSelectionTitle, translate]);
};

export default useSelectionIdToTitle;
